var parallaxBackground;
var receiptFileData = "";
var receiptName = "";
var products1 = ["Canon EF 14mm f / 2.8L II USM", "Canon EF 24mm f / 1.4L II USM", "Canon EF 35mm f / 1, 4L USM", "Canon EF 35mm f / 1.4L II USM", "Canon EF 50mm f / 1, 2L USM", "Canon EF 85mm f / 1, 2L II USM", "Canon EF 85mm f / 1.4L IS USM", "Canon EF 135mm f / 2L USM", "Canon EF 200mm f / 2L IS USM", "Canon EF 200mm f / 2, 8L II USM", "Canon EF 300mm f / 2.8L IS II USM", "Canon EF 300mm f / 4L IS USM", "Canon EF 400mm f / 2.8L IS II USM", "Canon EF 400mm f / 2.8L IS III USM", "Canon EF 400mm f / 4 DO IS II USM", "Canon EF 400mm f / 5, 6L USM", "Canon EF 500mm f / 4L IS II USM", "Canon EF 600mm f / 4L IS II USM", "Canon EF 600mm f / 4L IS III USM", "Canon EF 800mm f5.6L IS USM"];
var products2 = ["Canon EF 8 - 15mm f / 4L USM", "Canon EF 11 - 24mm f / 4L USM", "Canon EF 16 - 35mm f / 2.8L III USM", "Canon EF 16 - 35mm f / 2.8L II USM", "Canon EF 16 - 35mm f / 4L IS USM", "Canon EF 17 - 40mm f / 4L USM", "Canon EF 17 - 40mm f / 4L USM CZ", "Canon EF 24 - 70mm f / 2.8L II USM", "Canon EF 24 - 70mm f / 4L IS USM", "Canon EF 24 - 105mm f / 4L IS USM", "Canon EF 24 - 105mm f / 4L IS II USM", "Canon EF 28 - 300mm f / 3.5 - 5.6L IS USM", "Canon EF 70 - 200mm f / 2.8L IS II USM", "Canon EF 70 - 200mm f / 2.8L IS III USM", "Canon EF 70 - 200mm f / 4L USM", "Canon EF 70 - 200mm f / 4L IS USM", "Canon EF 70 - 200mm f / 4L IS II USM", "Canon EF 70 - 200mm f / 2.8L USM", "Canon EF 70 - 300mm f / 4 - 5.6L IS USM", "Canon EF 70 - 300mm f / 4.5 - 5.6 DO IS USM", "Canon EF 100 - 400mm f / 4.5 - 5.6L IS II USM", "Canon EF 200 - 400mm f4L IS USM + Extender 1.4x"];
var products3 = ["Canon EF 100mm f / 2.8L Macro IS USM", "Canon EF 180mm f / 3.5L USM Macro"];
var products4 = ["Canon TS - E 17mm f / 4L", "Canon TS - E 24mm f / 3.5L II", "Canon TS - E 50mm f / 2.8L Macro", "Canon TS - E 90mm f / 2.8L Macro", "Canon TS - E 135mm f / 4L Macro"];
var products5 = ["Canon RF 50mm f / 1.2L USM", "Canon RF 24 - 105mm f / 4L IS USM", "Canon RF 28 - 70mm f / 2L USM"];


function updateParallaxPosition() {
	var top = $(window).scrollTop();
	var backgroundTop = Math.round(top / 1.8);

	parallaxBackground.css('transform', 'translateY(' + backgroundTop + 'px' + ')');
}

function initParallax() {
	$(window).scroll(function () {
		updateParallaxPosition();
	});
	updateParallaxPosition();
}

function initScrollToElement() {
	var link = $('.scrollToElement');

	link.click(function (e) {
		e.preventDefault();
		var offset;
		var el = $(this).data('element');
		var element = $(el).first();
		var elementTop = Math.round(element.offset().top + (!isNaN(offset) ? offset : 0));

		$('html, body').stop().animate({ scrollTop: elementTop }, 1000, 'swing');
	});
}

function initDatePicker() {

	var options = {
		'locale': 'cs',
		'dateFormat': 'd. m. Y'
	};

	$(".date").flatpickr(options);
}

function initFileUpload() {
	$("input#fileInput").change(function (e) {
		receiptFile = e.target.files[0];
		receiptName = e.target.files[0].name;
		console.log('file uploading');
		var reader = new FileReader();
		if (receiptFile) {
			console.log('file uploading started');
			reader.readAsDataURL(receiptFile);
		}
		reader.addEventListener("load", function () {
			receiptFileData = reader.result;
			console.log('file uploaded successfully');
		}, false);
	});
}

function initSubmitRegistration() {
	$("#form").on('submit', function (e) {
		e.preventDefault();

		var form = $('#form');
		var fullname = form.find('input[name=fullname]')[0].value;
		var address = form.find('input[name=address]')[0].value;
		var city = form.find('input[name=city]')[0].value;
		var zip = form.find('input[name=zip]')[0].value;
		var phone = form.find('input[name=phone]')[0].value;
		var email = form.find('input[name=email]')[0].value;
		var product = form.find('input[name=product]')[0].value;
		var serial = form.find('input[name=serial]')[0].value;
		var buydate = form.find('input[name=buydate]')[0].value;
		var reseller = form.find('input[name=reseller]')[0].value;
		/* var account = form.find('input[name=account]')[0].value;
		var code = form.find('input[name=code]')[0].value; */
		var agree = form.find('input[name=agree]')[0];

		var formData = {
			fullname: fullname,
			address: address,
			city: city,
			zip: zip,
			phone: phone,
			email: email,
			product: product,
			serial: serial,
			buydate: buydate,
			reseller: reseller,
			/* account: account, */
			receiptName: receiptName,
			receiptFileData: receiptFileData,
			/* code: code, */
			agree: agree.checked ? true : false
		};
		console.log('data', formData);
		$.ajax({
			method: "POST",
			url: "https://www.salespromo.cz/canon/cisteni-zdarma/create",
			data: JSON.stringify(formData),
			success: function (data) {
				data = JSON.parse(data);
				if (data.status !== 1) {
					$("#state p").text(data.message);
					$("#state").removeClass("callout-success").addClass("callout-error").slideDown();
				} else {
					$("#form").slideUp();
					$("#state p").html("Registrace proběhla úspěšně!");
					$("#state").removeClass("callout-error").addClass("callout-success").slideDown();
				}
			},
			error: function (jqXHR, textStatus, errorThrown) {
				$("#state p").text(textStatus);
				$("#state").removeClass("callout-success").addClass("callout-error").slideDown();
			}
		});
	});
}

function initShowProducts() {
	var popup = $('.popup');
	var overlay = $('.overlay');
	var link = $('.open-popup');
	var close = $('.close');

	link.click(function (e) {
		e.preventDefault();
		var products = $(this).data('products');
		overlay.show(0);
		popup.show(0);


		switch (products) {
			case 'products1':
				popup.find('h3').text('Pevná ohniska');
				for (var i = 0; i < products1.length; i++) {
					popup.find('ul').append('<li>' + products1[i] + '</li>');
				}
				break;
			case 'products2':
				popup.find('h3').text('Zoomy');
				for (var i = 0; i < products2.length; i++) {
					popup.find('ul').append('<li>' + products2[i] + '</li>');
				}
				break;
			case 'products3':
				popup.find('h3').text('Makro');
				for (var i = 0; i < products3.length; i++) {
					popup.find('ul').append('<li>' + products3[i] + '</li>');
				}
				break;
			case 'products4':
				popup.find('h3').text('Tilt-Shift');
				for (var i = 0; i < products4.length; i++) {
					popup.find('ul').append('<li>' + products4[i] + '</li>');
				}
				break;
			case 'products5':
				popup.find('h3').text('RF objektivy');
				for (var i = 0; i < products5.length; i++) {
					popup.find('ul').append('<li>' + products5[i] + '</li>');
				}
				break;
		}

	});

	close.click(function (e) {
		e.preventDefault();
		popup.hide(0);
		overlay.hide(0);
		popup.find('ul').empty();
		popup.find('h3').empty();
	});
}

$(document).ready(function () {
	parallaxBackground = $('.parallax-background');

	initParallax();
	initShowProducts();
	initDatePicker();
	initFileUpload();
	initScrollToElement();
	initSubmitRegistration();

});

